import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Divider, mediaBreakpointMixin, IconButton, Box, IconChevronUp, IconChevronDown } from '@zillow/constellation';
import React from 'react';
import styled from 'styled-components';
import { GROUP_WIDTH_MAP } from '../../mixins/components/GroupMixin.js';
import SearchBox from './SearchBox.js';

var StyledDivider = /*#__PURE__*/styled(Divider).withConfig({
  componentId: "sc-mir6ll-0"
})(["@media ", "{display:none;}"], mediaBreakpointMixin('lg_lte'));
var StyledDropdownButton = /*#__PURE__*/styled(IconButton).withConfig({
  componentId: "sc-mir6ll-1"
})(["margin-top:2px;@media ", "{display:none;}"], mediaBreakpointMixin('xl_gte'));
var SubnavLink = function SubnavLink(_ref) {
  var url = _ref.url,
    title = _ref.title,
    home = _ref.home;
  // Common styles for both link and label
  var commonStyles = {
    textDecoration: 'none',
    fontWeight: home ? '$fontWeights.bold' : '$fontWeights.body',
    fontSize: '$fontSizes.bodySmall',
    fontFamily: '$fonts.sansSerif',
    color: home ? '$colors.textDark' : '$colors.textMedium'
  };

  // If no URL is provided, render as a label only
  if (!url || url.trim() === '') {
    return /*#__PURE__*/React.createElement(Box, {
      sx: Object.assign({}, commonStyles, {
        cursor: 'default'
      })
    }, title);
  }

  // Render as a clickable link
  return /*#__PURE__*/React.createElement(Box, {
    as: "a",
    href: url,
    sx: Object.assign({}, commonStyles, {
      ':hover': {
        textDecoration: 'underline',
        color: '$colors.blue500'
      }
    })
  }, title);
};
var B2BSubnav = function B2BSubnav(_ref2) {
  var primaryItem = _ref2.primaryItem,
    _ref2$items = _ref2.items,
    items = _ref2$items === void 0 ? [] : _ref2$items,
    searchPrefix = _ref2.searchPrefix,
    searchPlaceholder = _ref2.searchPlaceholder;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      borderBottom: '1px solid $colors.borderLight'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      height: '58px',
      position: 'relative',
      padding: '0 $spacing.sm',
      maxWidth: GROUP_WIDTH_MAP.xl,
      margin: '0 auto'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'stretch',
      '@media $lg_lte': {
        alignItems: 'center'
      }
    }
  }, primaryItem && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SubnavLink, {
    url: primaryItem.url,
    title: primaryItem.title,
    home: true
  }), /*#__PURE__*/React.createElement(StyledDivider, {
    orientation: "vertical",
    marginX: "md"
  })), /*#__PURE__*/React.createElement(StyledDropdownButton, {
    buttonType: "tertiary",
    bare: true,
    size: "xs",
    "aria-expanded": isOpen ? 'true' : 'false',
    icon: isOpen ? /*#__PURE__*/React.createElement(IconChevronUp, null) : /*#__PURE__*/React.createElement(IconChevronDown, null),
    title: "Open menu",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: '$spacing.lg',
      '@media $lg_lte': {
        display: 'none'
      }
    }
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement(Box, {
      key: item.id
    }, /*#__PURE__*/React.createElement(SubnavLink, {
      url: item.url,
      title: item.title
    }));
  }))), searchPrefix && /*#__PURE__*/React.createElement(SearchBox, {
    placeholder: searchPlaceholder ? searchPlaceholder : 'Search',
    actionPrefix: searchPrefix
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: isOpen ? 'block' : 'none',
      alignItems: 'center',
      gap: '$spacing.lg',
      backgroundColor: '$colors.backgroundLight',
      '@media $xl_gte': {
        display: 'none'
      },
      padding: '$spacing.md $spacing.sm',
      borderBottom: '1px solid $colors.borderLight',
      boxShadow: '$shadows.shadow200',
      borderRadius: '0 0 $radii.lg $radii.lg'
    }
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement(Box, {
      key: item.id,
      sx: {
        marginBottom: '$spacing.md',
        ':last-child': {
          marginBottom: 0
        }
      }
    }, /*#__PURE__*/React.createElement(SubnavLink, {
      url: item.url,
      title: item.title
    }));
  })));
};
var B2BSubnav$1 = B2BSubnav;

export { B2BSubnav$1 as default };
